(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-faq"] && !Shopify.designMode) return;
  try {
    function syncCollectionFaq(root) {
    var content = root.querySelector('[data-faq-content]');
    var toggle = root.querySelector('[data-faq-toggle]');
    var label = toggle && toggle.querySelector('[data-faq-toggle-label]');
    if (!content || !toggle) return;

    var expanded = content.classList.contains('is-expanded');
    content.classList.add('is-expanded');
    var fullHeight = content.scrollHeight;
    content.classList.remove('is-expanded');
    var overflow = fullHeight - content.clientHeight > 1;
    toggle.hidden = !overflow;

    if (!overflow) {
      toggle.setAttribute('aria-expanded', 'false');
      return;
    }

    if (expanded) {
      content.classList.add('is-expanded');
    }

    toggle.setAttribute('aria-expanded', String(expanded));
    if (label) {
      label.textContent = toggle.getAttribute(expanded ? 'data-label-less' : 'data-label-more');
    }
  }

  function initCollectionFaq(scope) {
    (scope || document).querySelectorAll('[data-collection-faq]').forEach(syncCollectionFaq);
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-faq-toggle]');
    if (!toggle) return;
    var root = toggle.closest('[data-collection-faq]');
    if (!root) return;

    var content = root.querySelector('[data-faq-content]');
    var expanded = content.classList.toggle('is-expanded');
    toggle.setAttribute('aria-expanded', String(expanded));
    var label = toggle.querySelector('[data-faq-toggle-label]');
    if (label) {
      label.textContent = toggle.getAttribute(expanded ? 'data-label-less' : 'data-label-more');
    }
  });

  window.addEventListener('resize', function () {
    initCollectionFaq();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initCollectionFaq(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCollectionFaq();
    });
  } else {
    initCollectionFaq();
  }

  if (document.fonts) {
    document.fonts.ready.then(function () {
      initCollectionFaq();
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-intro"] && !Shopify.designMode) return;
  try {
    function fitWholeWords(preview) {
    var text = preview.dataset.fullText;
    preview.textContent = text;

    if (preview.scrollWidth <= preview.clientWidth) return false;

    var words = text.split(/\s+/);
    var low = 0;
    var high = words.length;

    while (low < high) {
      var middle = Math.ceil((low + high) / 2);
      preview.textContent = words.slice(0, middle).join(' ');

      if (preview.scrollWidth <= preview.clientWidth) {
        low = middle;
      } else {
        high = middle - 1;
      }
    }

    preview.textContent = words.slice(0, Math.max(low, 1)).join(' ');
    return true;
  }

  function syncIntro(root) {
    var content = root.querySelector('[data-intro-content]');
    var preview = root.querySelector('[data-intro-preview]');
    var toggle = root.querySelector('[data-intro-toggle]');
    var label = toggle && toggle.querySelector('[data-intro-toggle-label]');
    if (!content || !preview || !toggle) return;

    var expanded = root.classList.contains('is-expanded');
    if (!preview.dataset.fullText) {
      preview.dataset.fullText = preview.textContent.trim().replace(/\s+/g, ' ');
    }

    root.classList.remove('is-collapsed', 'is-expanded');
    preview.hidden = false;
    content.hidden = true;
    var overflow = fitWholeWords(preview);
    toggle.hidden = !overflow;

    if (!overflow) {
      preview.hidden = true;
      content.hidden = false;
      toggle.setAttribute('aria-expanded', 'false');
      return;
    }

    if (expanded) {
      root.classList.add('is-expanded');
      preview.hidden = true;
      content.hidden = false;
    } else {
      root.classList.add('is-collapsed');
    }

    toggle.setAttribute('aria-expanded', String(expanded));
    if (label) {
      label.textContent = toggle.getAttribute(expanded ? 'data-label-less' : 'data-label-more');
    }
  }

  function initIntro(scope) {
    (scope || document).querySelectorAll('[data-collection-intro]').forEach(syncIntro);
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-intro-toggle]');
    if (!toggle) return;
    var root = toggle.closest('[data-collection-intro]');
    if (!root) return;

    var expanded = root.classList.toggle('is-expanded');
    root.classList.toggle('is-collapsed', !expanded);
    root.querySelector('[data-intro-preview]').hidden = expanded;
    root.querySelector('[data-intro-content]').hidden = !expanded;
    toggle.setAttribute('aria-expanded', String(expanded));
    var label = toggle.querySelector('[data-intro-toggle-label]');
    if (label) {
      label.textContent = toggle.getAttribute(expanded ? 'data-label-less' : 'data-label-more');
    }
  });

  window.addEventListener('resize', function () {
    initIntro();
  });
  document.addEventListener('shopify:section:load', function (event) {
    initIntro(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initIntro();
    });
  } else {
    initIntro();
  }

  if (document.fonts) {
    document.fonts.ready.then(function () {
      initIntro();
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-seo-text"] && !Shopify.designMode) return;
  try {
    function syncSeoText(root) {
    var content = root.querySelector('[data-seo-text-content]');
    var toggle = root.querySelector('[data-seo-text-toggle]');
    var label = toggle && toggle.querySelector('[data-seo-text-toggle-label]');
    if (!content || !toggle) return;

    var expanded = content.classList.contains('is-expanded');
    content.classList.add('is-expanded');
    var fullHeight = content.scrollHeight;
    content.classList.remove('is-expanded');
    var overflow = fullHeight - content.clientHeight > 1;
    toggle.hidden = !overflow;

    if (!overflow) {
      toggle.setAttribute('aria-expanded', 'false');
      return;
    }

    if (expanded) {
      content.classList.add('is-expanded');
    }

    toggle.setAttribute('aria-expanded', String(expanded));
    if (label) {
      label.textContent = toggle.getAttribute(expanded ? 'data-label-less' : 'data-label-more');
    }
  }

  function initSeoText(scope) {
    (scope || document).querySelectorAll('[data-collection-seo-text]').forEach(syncSeoText);
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-seo-text-toggle]');
    if (!toggle) return;
    var root = toggle.closest('[data-collection-seo-text]');
    if (!root) return;

    var content = root.querySelector('[data-seo-text-content]');
    var expanded = content.classList.toggle('is-expanded');
    toggle.setAttribute('aria-expanded', String(expanded));
    var label = toggle.querySelector('[data-seo-text-toggle-label]');
    if (label) {
      label.textContent = toggle.getAttribute(expanded ? 'data-label-less' : 'data-label-more');
    }
  });

  window.addEventListener('resize', function () {
    initSeoText();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initSeoText(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSeoText();
    });
  } else {
    initSeoText();
  }

  if (document.fonts) {
    document.fonts.ready.then(function () {
      initSeoText();
    });
  }
  } catch(e) { console.error(e); }
})();

})();
